module.exports = __webpack_public_path__ + "img/welcome_13.2c34e171.jpg";